module.exports = __webpack_public_path__ + "img/publish-0-ph.50696c70.png";